import { Badge, BadgeProps, MantineColor } from '@mantine/core';
import React from 'react';

import { AnalyticsCustomerStatus } from '@portals/api/partners';

const customerStatusToColorDict: Record<AnalyticsCustomerStatus, MantineColor> =
  {
    New: 'indigo.0',
    Active: 'teal.0',
    'Low Activity': 'orange.1',
    Churned: 'red.1',
  };

interface StatusBadgeProps {
  status: AnalyticsCustomerStatus;
}

export function CustomerAnalyticsStatusBadge({ status }: StatusBadgeProps) {
  const getBadgeStyles: BadgeProps['styles'] = (theme) => ({
    root: {
      borderRadius: theme.radius.lg,
      backgroundColor: theme.fn.themeColor(customerStatusToColorDict[status]),
    },
    inner: {
      color: 'gray.9',
      fontSize: theme.fontSizes.xs,
      fontWeight: 400,
    },
  });

  return <Badge styles={getBadgeStyles}>{status}</Badge>;
}
